import EventCategoryRestrictions from './EventCategoryRestrictions';

export default EventCategoryRestrictions;
